import AccessibilityContent from "../../../../src/pages/pricing/contact/sales/accessibility-content.md";
import { PdfAccessibility } from "../../../../src/components/pdfAccessibility";
import * as React from 'react';
export default {
  AccessibilityContent,
  PdfAccessibility,
  React
};